export default "__VITE_ASSET__D7O6Lszw__"